const getModuleState = state => state.location;

export const getProvinces = state => getModuleState(state).provinces;

export const getMunicipalitiesByProvince = state => getModuleState(state).municipalitiesByProvince;

export const getParishesByMunicipality = state => getModuleState(state).parishesByMunicipality;